import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../assets/scss/login.scss";
import { Button, Error, Image, Label } from "../../shared/Components";
import LoginSchema from "../../shared/Schema/LoginSchema";
import Icon from "../../assets/icons/Icon";
import { clearStorage, loginUser } from "../../store/user/user-action";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showHide, setShowHide] = useState(false);

  useEffect(() => {
    clearStorage();
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      userName: "",
      password: "",
    },
    resolver: yupResolver(LoginSchema),
    mode: "onTouched",
  });

  const onSubmit = async (values) => {
    await loginUser(dispatch, values, navigate);
  };

  return (
    <section className="body_box">
      <div className="login-part">
        <div className="logo_box">
          <Image
            src="/assets/images/logo.png"
            alt="logo"
            className="logo_img"
          />
        </div>
        <p className="titan_text">Sign in to continue to DG Office.</p>
        <form onSubmit={handleSubmit(onSubmit)}>
          <fieldset disabled={isSubmitting}>
            <div className=" input_box_card">
              <Label className="form-label" for="userName">
                Username
              </Label>
              <input
                type="text"
                className="form-control"
                id="userName"
                placeholder="Enter username"
                autoFocus
                tabIndex={1}
                {...register("userName")}
              />
              {errors.userName && (
                <Error className="error-text">{errors.userName.message}</Error>
              )}
            </div>
            <div className="input_box_card">
              <Label className="form-label" for="password">
                Password
              </Label>
              <input
                type={showHide ? "text" : "password"}
                className="form-control"
                id="password"
                placeholder="Enter password"
                tabIndex={2}
                {...register("password")}
              />

              <div
                className="eye_icon"
                onClick={() => setShowHide((prev) => !prev)}
              >
                {showHide ? <Icon name="EyeClosed" /> : <Icon name="Eye" />}
              </div>

              {errors.password && (
                <Error className="error-text">{errors.password.message}</Error>
              )}
            </div>
            <Button
              className="btn login-button"
              type="submit"
              icon="FaSignInAlt"
              isDisabled={isSubmitting}
              tabIndex={3}
            >
              {isSubmitting ? "Loading..." : "Submit"}
            </Button>
          </fieldset>
        </form>
      </div>
    </section>
  );
};

export default Login;
